import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableAppBlackoutsPostalCodesCatalog from './tableAppBlackoutsPostalCodesCatalog';

export default {
  title: 'General',
  attributeName: 'blackouts',
  fields: [
    {
      attributeName: 'tagName',
      helpText: 'Name of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Tag Name',
      placeholder: 'Name...',
      visibleWhen: {
        field: 'tagType',
        value: ['category']
      }
    },
    {
      attributeName: 'tagName',
      helpText: 'Name of the tag',
      label: 'Tag Name',
      placeholder: 'Name...',
      type: FormInputTypes.SELECT,
      options: [
        { name: '(No action)', value: '(Empty)' },
        { name: 'Sports', value: 'sports' },
        { name: 'Music', value: 'music' },
        { name: 'Tourism', value: 'tourism' },
        { name: 'Art', value: 'art' },
        { name: 'Acting', value: 'acting' },
        { name: 'Cinema', value: 'cinema' },
        { name: 'Theatre', value: 'theatre' },
        { name: 'Dance', value: 'dance' },
        { name: 'Education', value: 'education' },
        { name: 'Technology', value: 'technology' }
      ],
      visibleWhen: {
        field: 'tagType',
        value: ['domain']
      }
    },
    {
      attributeName: 'tagType',
      label: 'Tag Type',
      helpText: 'Type of the tag.',
      default: 'enabled',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      hidden: true
    },
    {
      attributeName: 'score',
      helpText: 'Score of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Score',
      placeholder: 'Score...',
       disableWhen: {
        field: 'tagType',
        value: ['domain','category']
      }
    },
  ],
};

